export function getVerifyResponseDisplay(member) {
	var quoteResponse = {
		underwriterId: -1,
		underwriterName: '',
		underwritingSucceeded: false,
		policyStartDate: '',
		product: {},
		currency: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			currencyId: -1,
			currencyName: '',
		},
		insured: [],
	}

	for (var i = 0; i < member; i++) {
		quoteResponse.insured.push(insuredDisplay())
	}

	return quoteResponse
}

function insuredDisplay() {
	return {
		insuredId: '',
		name: '',
		isAPolicyHolder: false,
		totalUnderWritingPoints: 0,
		totalUnderWritingPercent: 0,
		totalUnderWritingAmount: 0,
		underwritingPolicyRule: {
			underwritingPolicyRuleId: -1,
			underwritingPolicyRuleName: 0,
		},
		dateOfBirth: '',
		frequencySelected: {},
		gender: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			genderId: -1,
			genderName: '',
		},
		occupation: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			dangerousOccupation: false,
			occupationId: -1,
			occupationName: '',
		},
		countryOfNationality: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			countryId: -1,
			countryName: '',
			regionId: -1,
		},
		countryOfResidence: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			countryId: -1,
			countryName: '',
			regionId: -1,
		},
		bmi: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			bmi: 0,
			bmiStatusName: '',
		},
		pastime: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			pastimeId: -1,
			pastimeName: '',
		},
		relationshipToPolicyHolder: {
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
			relationshipToPolicyHolderId: -1,
			relationshipName: '',
		},
		ageBand: {
			ageBandId: -1,
			ageBandName: '',
			productId: -1,
			underWritingPoints: 0,
			underWritingPercent: 0,
			underWritingAmount: 0,
		},
		questions: [],
	}
}

export function getFormDataCopy() {
	return {
		applicationFormJsonVersion: '1.7.0',
		applicationCreatedDate: new Date().toString(),
		applicationCreatedDateISO8601: new Date().toISOString(),
		isLive: false,
		brokerCompanyId: -1,
		brokerCompanyName: 'Direct',
		brokerRef: '',
		insurerId: -1,
		insurerCompanyName: '',
		underwriterId: -1,
		underwriterName: '',
		id: '',
		formName: '',
		insuranceTypeId: -1,
		insuranceTypeName: '',
		policyNumber: '',
		applyOrPaymentComplete: false,
		certificateGenerate: false,

		paymentStatus: '',
		workflow: '',

		//Policy detail + product + underwriting
		policyDetails: {
			policyStartDate: '',
			policyHolderInsured: true,
			currencyId: -1,
			currencyName: '',
		},
		product: {
			productId: -1,
			productName: '',

			areaOfCoverId: -1,
			areaOfCoverName: '',
			areaOfCoverCountryXrefEndorsement: '',

			levelOfCoverId: -1,
			levelOfCoverName: '',

			voluntaryExcessId: -1,
			voluntaryExcessName: '',
			voluntaryExcessEndorsement: '',

			mandatoryExcesses: [],

			coInsurances: [],

			benefits: [],

			frequencySelected: {},

			currency: {},
		},
		underwritingTypeId: -1,
		underwritingTypeName: '',
		underwritingTermsEndorsement: '',

		policyHolder: {
			id: '',
			details: {
				insuredId: '',
				salutationId: -1,
				salutationName: '',
				surname: '',
				forename: '',
				dateOfBirth: '',
				genderId: -1,
				genderName: '',
				occupationId: -1,
				occupationName: '',
				jobTitle: '',
				industry: '',
				countryOfResidence: {},
				nationality: {},
				isTaxIdentificationRequired: false, // residence country = portugal => enable = true
				taxIdentificationNumber: '',
			},

			contactDetails: {
				lineNumberCountryCodeId: -1,
				lineNumberCountryCodeName: '',
				landlineNumber: '',
				countryCodeMobileId: -1,
				countryCodeMobileName: '',
				mobileNumber: '',
				emailAddress: '',
			},

			additionalDetails: {
				isSportOrPastime: true,
				pastimeId: -1,
				pastimeName: '',
				otherPastimes: '',

				refusedCoverOrAcceptedOnSpecialTerms: false,
				refusedCoverOrAcceptedOnSpecialTermsDate: '',
				refusedCoverOrAcceptedOnSpecialTermsDetails: '',

				smoking: false,
				smokingAnswerHowMany: '',

				haveExistingHealthInsurance: false,
				insuranceProvider: {},

				bmi: {
					unit: 0,
					centimeters: 0,
					kilograms: 0,
					feets: 0,
					inches: 0,
					stones: 0,
					pounds: 0,
				},

				countryResidenceAddress: {
					address1: '',
					address2: '',
					address3: '',
					state: '',
					city: '',
					zipCode: '',
					countryId: -1,
					countryCodeName: '',
				},

				homeCountryAddress: {
					address1: '',
					address2: '',
					address3: '',
					state: '',
					city: '',
					zipCode: '',
					countryId: -1,
					countryCodeName: '',
				},

				physicianDetails: {
					salutationId: -1,
					salutationName: '',
					forename: '',
					surname: '',
					practiceName: '',
					dateLastVisited: '',
					email: '',
					countryCodeId: -1,
					countryCodeName: '',
					telephoneNumber: '',
					address: {
						address1: '',
						address2: '',
						address3: '',
						state: '',
						city: '',
						countryId: -1,
						countryName: '',
						zipCode: '',
					},
					haveExistingHealthInsurance: false,
					insuranceProvider: {},
				},

				documents: [],
			},
		},
		underwritingQuestions: [],
		summary: {},

		familyMembers: [],

		insuredPremiumBreakdownByPaymentFrequency: {},

		applicationTime: {
			startTime: '',
			steps: {},
			endTime: '',
			elapsedTime: '',
		},

		userActivity: [],

		logSteps: [],
		userEnvironmentInfo: {},
	}
}

export function getFamilyCopy() {
	return {
		id: '',
		details: {
			insuredId: '',
			salutationId: -1,
			salutationName: '',
			surname: '',
			forename: '',
			dateOfBirth: '',
			genderId: -1,
			genderName: '',
			occupationId: -1,
			occupationName: '',
			jobTitle: '',
			industry: '',
			nationality: {},
			relationshipId: -1,
			relationshipName: '',
			relationshipToPolicyHolder: {
				relationshipToPolicyHolderId: -1,
				relationshipName: '',
			},
		},
		additionalDetails: {
			isSportOrPastime: true,
			pastimeId: -1,
			otherPastimes: '',

			smoking: false,
			smokingAnswerHowMany: '',

			refusedCoverOrAcceptedOnSpecialTerms: false,
			refusedCoverOrAcceptedOnSpecialTermsDate: '',
			refusedCoverOrAcceptedOnSpecialTermsDetails: '',
			bmi: {
				unit: 0,
				centimeters: 0,
				kilograms: 0,
				feets: 0,
				inches: 0,
				stones: 0,
				pounds: 0,
			},
			physicianDetails: {
				physicianSamePolicyHolder: false,
				salutationId: -1,
				forename: '',
				surname: '',
				practiceName: '',
				dateLastVisited: '',
				email: '',
				countryCodeId: -1,
				telephoneNumber: '',
				address: {
					address1: '',
					address2: '',
					address3: '',
					state: '',
					city: '',
					countryId: -1,
					zipCode: '',
				},

				healthInsuraceSamePolicyHolder: false,
				haveExistingHealthInsurance: false,
				insuranceProvider: {
					coverEndDate: '',
					providerCompanyName: '',
				},
			},
			documents: [],
		},
		underwritingQuestions: [],
	}
}
